import React from 'react';

export default function PartnersPage() {
  return (
    <div className="dashboard">
      <h1>Partners</h1>

      <div className="stream-setup">
        <h2>Ninty Partner Program</h2>
        <p style={{ fontSize: '0.95rem', color: '#adadb8', lineHeight: 1.7, marginBottom: '20px' }}>
          Our partners are the heart of Ninty. As a verified partner, you get exclusive perks, priority support, and tools to grow your community.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '24px' }}>
          {[
            { perk: 'Verified Badge', desc: 'Stand out with a verified partner badge on your profile and in chat', color: 'var(--accent)' },
            { perk: 'Priority Support', desc: 'Direct line to our team for any issues or feature requests', color: '#42a5f5' },
            { perk: 'Custom Emotes', desc: 'Upload custom channel emotes for your subscribers', color: '#ff6b9d' },
            { perk: 'Revenue Boost', desc: 'Earn 92% on tips and subs (vs standard 90%)', color: '#ffd700' },
            { perk: 'Early Access', desc: 'Be first to try new features before they launch', color: '#ce93d8' },
            { perk: 'Co-marketing', desc: 'Get featured on our social channels and homepage', color: '#ff9800' },
          ].map((p, i) => (
            <div key={i} style={{ display: 'flex', gap: '14px', padding: '16px', background: '#0e0e10', borderRadius: '2px', border: '1px solid #2a2a2e', boxShadow: '2px 2px 0 rgba(0,0,0,0.3)' }}>
              <div style={{ width: 4, background: p.color, borderRadius: '2px', flexShrink: 0 }} />
              <div>
                <div style={{ fontWeight: 800, fontSize: '0.95rem', marginBottom: '4px' }}>{p.perk}</div>
                <div style={{ fontSize: '0.82rem', color: '#adadb8', lineHeight: 1.5 }}>{p.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="stream-setup">
        <h2>Requirements</h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '20px' }}>
          {[
            'Stream regularly (at least 3x per week)',
            'Have an active, growing community',
            'Follow all community guidelines',
            'Be a positive representative of the platform',
          ].map((req, i) => (
            <div key={i} style={{ display: 'flex', gap: '10px', alignItems: 'center', fontSize: '0.88rem' }}>
              <span style={{ fontFamily: 'var(--font-pixel)', fontSize: '0.5rem', color: 'var(--accent)' }}>{'>'}</span>
              <span style={{ color: '#adadb8' }}>{req}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="stream-setup">
        <h2>Apply</h2>
        <p style={{ fontSize: '0.9rem', color: '#adadb8', lineHeight: 1.6, marginBottom: '16px' }}>
          Think you're a good fit? We'd love to have you.
        </p>
        <a href="mailto:partners@ninty.live" className="btn btn-primary" style={{ display: 'inline-block', textDecoration: 'none' }}>
          partners@ninty.live
        </a>
      </div>
    </div>
  );
}
